import { render } from "./CoBrandSage.vue?vue&type=template&id=4a3c219f&scoped=true"
import script from "./CoBrandSage.vue?vue&type=script&lang=js"
export * from "./CoBrandSage.vue?vue&type=script&lang=js"

import "./CoBrandSage.vue?vue&type=style&index=0&id=4a3c219f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c219f"]])

export default __exports__